import {
  createTagOverride,
  TextAlignment,
  TextAppearance,
  TextCustom,
  TextTag
} from '@vw-marketing/us-components';

const descriptionTextStyle = createTagOverride(TextCustom, {
  appearance: TextAppearance.headline200,
  style: {textAlign: TextAlignment.center},
  tag: TextTag.p
});

export const descriptionSuccessTextStyle: any = {
  div: descriptionTextStyle,
  p: descriptionTextStyle,
  span: descriptionTextStyle
};
